import _extends from '@babel/runtime/helpers/extends';
import React from 'react';
import { dgResolveObjString } from 'dg-utils';

var img = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='iso-8859-1'%3f%3e%3c!-- Generator: Adobe Illustrator 16.0.0%2c SVG Export Plug-In . SVG Version: 6.00 Build 0) --%3e%3c!DOCTYPE svg PUBLIC '-//W3C//DTD SVG 1.1//EN' 'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'%3e%3csvg version='1.1' id='Capa_1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='973.1px' height='973.1px' viewBox='0 0 973.1 973.1' style='enable-background:new 0 0 973.1 973.1%3b' xml:space='preserve' %3e%3cg%3e %3cpath d='M502.29%2c788.199h-47c-33.1%2c0-60%2c26.9-60%2c60v64.9c0%2c33.1%2c26.9%2c60%2c60%2c60h47c33.101%2c0%2c60-26.9%2c60-60v-64.9 C562.29%2c815%2c535.391%2c788.199%2c502.29%2c788.199z'/%3e %3cpath d='M170.89%2c285.8l86.7%2c10.8c27.5%2c3.4%2c53.6-12.4%2c63.5-38.3c12.5-32.7%2c29.9-58.5%2c52.2-77.3c31.601-26.6%2c70.9-40%2c117.9-40 c48.7%2c0%2c87.5%2c12.8%2c116.3%2c38.3c28.8%2c25.6%2c43.1%2c56.2%2c43.1%2c92.1c0%2c25.8-8.1%2c49.4-24.3%2c70.8c-10.5%2c13.6-42.8%2c42.2-96.7%2c85.9 c-54%2c43.7-89.899%2c83.099-107.899%2c118.099c-18.4%2c35.801-24.8%2c75.5-26.4%2c115.301c-1.399%2c34.1%2c25.8%2c62.5%2c60%2c62.5h49 c31.2%2c0%2c57-23.9%2c59.8-54.9c2-22.299%2c5.7-39.199%2c11.301-50.699c9.399-19.701%2c33.699-45.701%2c72.699-78.1 C723.59%2c477.8%2c772.79%2c428.4%2c795.891%2c392c23-36.3%2c34.6-74.8%2c34.6-115.5c0-73.5-31.3-138-94-193.4c-62.6-55.4-147-83.1-253-83.1 c-100.8%2c0-182.1%2c27.3-244.1%2c82c-52.8%2c46.6-84.9%2c101.8-96.2%2c165.5C139.69%2c266.1%2c152.39%2c283.5%2c170.89%2c285.8z'/%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3cg%3e%3c/g%3e%3c/svg%3e";

var input = function input(props) {
  var input = props.input,
    label = props.label,
    preventPastDate = props.preventPastDate,
    preventFutureDate = props.preventFutureDate,
    containerClass = props.containerClass,
    inputSymbol = props.inputSymbol,
    inputContainerClass = props.inputContainerClass,
    labelClass = props.labelClass,
    placeholder = props.placeholder,
    toolTipText = props.toolTipText,
    tipIcon = props.tipIcon,
    inputClass = props.inputClass;
    props.defaultChecked;
    props.type;
    props.onChange;
    props.disabled;
    props.autoComplete;
    props.step;
    props.min;
    props.max;
    var _props$meta = props.meta,
    asyncValidating = _props$meta.asyncValidating,
    touched = _props$meta.touched,
    error = _props$meta.error;
    _props$meta.warning;
  return /*#__PURE__*/React.createElement("div", {
    className: containerClass ? containerClass : "field-group"
  }, toolTipText ? /*#__PURE__*/React.createElement("div", {
    className: "toolTip"
  }, /*#__PURE__*/React.createElement("label", {
    className: labelClass
  }, label), /*#__PURE__*/React.createElement("img", {
    src: tipIcon ? tipIcon : img,
    className: "toolTip-image",
    alt: "tool tip"
  }), /*#__PURE__*/React.createElement("span", {
    className: "toolTipText"
  }, toolTipText)) : /*#__PURE__*/React.createElement("label", {
    className: labelClass
  }, label), inputSymbol ? /*#__PURE__*/React.createElement("div", {
    className: inputContainerClass ? inputContainerClass : "form-input-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement("div", {
    className: "input-group-text"
  }, inputSymbol), /*#__PURE__*/React.createElement("input", _extends({}, props, input, {
    placeholder: placeholder ? placeholder : label,
    className: inputClass
  }))), (touched && error || asyncValidating) && /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, error)) : /*#__PURE__*/React.createElement("div", {
    className: inputContainerClass ? inputContainerClass : "form-input-container"
  }, /*#__PURE__*/React.createElement("input", _extends({}, props, input, {
    placeholder: placeholder ? placeholder : label,
    className: inputClass,
    min: preventPastDate ? new Date().toISOString().split("T")[0] : "",
    max: preventFutureDate ? new Date().toISOString().split("T")[0] : ""
  })), (touched && error || asyncValidating) && /*#__PURE__*/React.createElement("span", {
    className: "form-error"
  }, error)));
};

var required = function required(value) {
  return value ? undefined : "Required";
};
var minValue = function minValue(min, minDisplay) {
  return function (value) {
    return value && value < min ? "Must be at least ".concat(minDisplay ? minDisplay : min) : undefined;
  };
};
var maxValue = function maxValue(max) {
  return function (value) {
    return value && value > max ? "Must be at least ".concat(max) : undefined;
  };
};
var maxLength = function maxLength(max) {
  return function (value) {
    return value && value.length > max ? "Must be ".concat(max, " characters or less") : undefined;
  };
};
var minLength = function minLength(min) {
  return function (value) {
    return value && value.length < min ? "Must be ".concat(min, " characters or more") : undefined;
  };
};
var alphaNumeric = function alphaNumeric(value) {
  return value && /[^a-zA-Z0-9 ]/i.test(value) ? "Only alphanumeric characters" : undefined;
};
var phoneNumber = function phoneNumber(value) {
  return value && !/^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{3,6}$/i.test(value) ? "Invalid phone number" : undefined;
};
var email = function email(value) {
  return value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) ? "Invalid email address" : undefined;
};
var addressSelected = function addressSelected(fieldName, errorMessage) {
  return function (value, allValues) {
    return value && !dgResolveObjString(fieldName, allValues) ? errorMessage || "Please select an address from the list. If no options are available, please modify your search." : undefined;
  };
};

export { maxValue as a, maxLength as b, minLength as c, alphaNumeric as d, email as e, addressSelected as f, input as i, minValue as m, phoneNumber as p, required as r };
